import { AnimatedLoader } from "@/app/ui/AnimatedLoader";
import Footer from "@/app/ui/Footer";
import PageLoader from "@/app/ui/PageLoader";
import { TravellerListV2 } from "@/app/ui/travellers/TravellersListV2";

import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { useTranslations } from "use-intl";

export const Route = createFileRoute("/_authenticated/travelers")({
  validateSearch: (search) => {
    if (search.edit) {
      return { edit: search.edit as string };
    }
    if (search.delete) {
      return { delete: search.delete as string };
    }
    if (search.new) {
      return { new: true };
    }
    return {};
  },
  component: RouteComponent,
});

function RouteComponent() {
  const t = useTranslations();
  const search = Route.useSearch();

  return (
    <main className="main">
      <Suspense
        fallback={
          <PageLoader>
            <AnimatedLoader icon="users" />
          </PageLoader>
        }
      >
        <div className="w-full p-4">
          <h4 className="mt-2 mb-4 text-base font-medium text-text-title">
            {t("travellers.listOfTravellers")}
          </h4>

          <TravellerListV2 {...search} />
        </div>
      </Suspense>
      <Footer />
    </main>
  );
}
